var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditComponentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7871 12.5769L19.4234 8.21318C19.1394 7.92926 18.679 7.92926 18.395 8.21318L8.21309 18.3951C8.07669 18.5315 8.00004 18.7164 8 18.9093V23.273C8 23.6746 8.32561 24.0002 8.72728 24.0002H13.091C13.2838 24.0002 13.4688 23.9236 13.6051 23.7872L23.7871 13.6052C24.071 13.3212 24.071 12.8609 23.7871 12.5769ZM12.7901 22.5457H9.45475V19.2104L16.7275 11.9376L20.0629 15.2729L12.7901 22.5457ZM17.7555 10.9092L21.0908 14.2445L22.2443 13.091L18.909 9.75574L17.7555 10.9092Z",
    fill: "#3030AD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5,
    stroke: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditComponentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editComponentIcon.f4b72ae9ac176db5ea91fa2b35a3f033.svg";